import { Vulnerability } from '../../../../../components/shared'

export enum DependencyType {
  ALL = 'ALL',
  PROD = 'PROD',
  DEV = 'DEV'
}

export interface SelectedFilters {
  [key: string]: string[]
}

// Removes 'readonly' attributes from a type's properties
type Writable<T> = { -readonly [P in keyof T]: T[P] }
export interface Report {
  readonly appID: string
  readonly cliVersion: string
  readonly snapshotCreatedAt: string
  readonly reportId: string
}

export interface ReportCli {
  readonly branchName: string
  readonly created: string
  readonly reportId: string
}

export type TreeType = 'CLI' | 'LegacyCLI'

export type Dependency = Writable<{
  readonly id: string
  readonly name: string
  readonly integrity: string | null
  readonly hasVulnerableDependency: boolean
  readonly children: Dependency[]
  readonly vulnerabilities: Vulnerability[]
  readonly type: string
  readonly group: string
  readonly resolved: string
}>

export interface ReportList {
  readonly reports: Report[]
}

export interface DependencyTreeResult {
  readonly dependencyTree: Dependency[]
  readonly vulnerabilities: Vulnerability[]
}

export interface DependencyTreeResponse {
  readonly data: ReportList
  readonly isLoading: boolean
  readonly error: string
}

export interface DependencyTreeViewResponse {
  readonly data: DependencyTreeResult
  readonly isLoading: boolean
  readonly error: string
}

export interface ModulesResponse {
  success: boolean
  messages: string[]
  applications: ModuleApplication[]
  parentApplication: ModuleApplication
}

export interface ModuleApplication {
  name: string
  path: string
  language: string
  created: number
  status: string
  importance: number
  archived: boolean
  assess: boolean
  assessPending: boolean
  primary: boolean
  master: boolean
  notes: string
  roles: string[]
  tags: any[]
  parentApplicationId?: string
  techs: any[]
  policies: any[]
  missingRequiredFields?: any
  protect?: any
  app_id: string
  last_seen: number
  last_reset?: any
  size_shorthand: string
  size: number
  code_shorthand: string
  code: number
  override_url?: any
  short_name?: any
  importance_description: string
  total_modules: number
  first_seen: number
}
